import './vendor';
import './ua-parser';
import './hover';

import './components/game';
import './components/share';